// utils/validation.js
export const validateOrderData = (orderDetails, vehicles, prizes) => {
  const errors = [];

  // Validate basic order details
  if (!orderDetails.jobNumber?.trim()) {
    errors.push('Job number is required');
  }

  if (orderDetails.quantity && (isNaN(orderDetails.quantity) || orderDetails.quantity < 0)) {
    errors.push('Quantity must be a positive number');
  }

  // Validate campaign name
  if (!orderDetails.campaignName?.trim()) {
    errors.push('Campaign name is required');
  }

  // Validate size
  if (!orderDetails.size?.trim()) {
    errors.push('Size is required');
  }

  // Validate drops
  if (!orderDetails.drops || orderDetails.drops.length === 0) {
    errors.push('At least one drop is required');
  } else {
    orderDetails.drops.forEach((drop, index) => {
      if (!drop.startDate || !drop.endDate) {
        errors.push(`Drop ${index + 1}: Both start and end dates are required`);
      } else {
        const start = new Date(drop.startDate);
        const end = new Date(drop.endDate);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
          errors.push(`Drop ${index + 1}: Invalid date format`);
        } else if (start > end) {
          errors.push(`Drop ${index + 1}: Start date must be before end date`);
        }
      }
      
      if (drop.quantity && (isNaN(drop.quantity) || drop.quantity < 0)) {
        errors.push(`Drop ${index + 1}: Quantity must be a positive number`);
      }
    });
  }

  // Validate vehicles (only if vehicles exist and have data)
  vehicles?.forEach((vehicle, index) => {
    const hasData = vehicle.year || vehicle.make || vehicle.model || vehicle.salePrice;
    
    if (hasData) {
      if (!vehicle.year) {
        errors.push(`Vehicle ${index + 1}: Year is required`);
      }
      if (!vehicle.make?.trim()) {
        errors.push(`Vehicle ${index + 1}: Make is required`);
      }
      if (!vehicle.model?.trim()) {
        errors.push(`Vehicle ${index + 1}: Model is required`);
      }
      if (!vehicle.salePrice || isNaN(vehicle.salePrice) || vehicle.salePrice <= 0) {
        errors.push(`Vehicle ${index + 1}: Sale price must be greater than 0`);
      }
    }
  });

  return errors;
};